<!-- 赛事信息 -->
<template>
    <div>
        <event-head></event-head>
        <div class="group-name" style="margin-top: 30px;">
        </div>
        <div class="sponsor">
            <el-table :data="posterData" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column prop="matchPosterId" label="海报id" align="center">
                </el-table-column>
                <el-table-column prop="sponsorLogo" label="海报图片" align="center">
                    <template slot-scope="scope">
                        <div class="posterPic" align="center">
                            <el-image :src="scope.row.posterPic" style="width: 80px;height: 80px;"></el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" style="width: 100%; white-space: nowrap" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deletePoster(scope.row)">删除海报</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="add">
                <el-image src="https://football-go.oss-cn-hangzhou.aliyuncs.com/pic/15-icon/60-xinzeng.png"
                    style="width:20px;height:20px" @click="addPoster"></el-image>
            </div>
        </div>
        <!-- 新增海报 -->
        <el-dialog :visible.sync="posterVisible" :title="posterTitle" width="40%" @close="closePosterDialog">
            <el-form ref="form" :model="posterForm" label-width="120px" class="infoForm">
                <el-form-item label="海报图片">
                    <f-image-upload v-model="posterForm.posterPic" @input="changePosterPic" style="margin-left: 0"
                        :width="'80px'" :height="'80px'"></f-image-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="posterVisible = false">取 消</el-button>
                <el-button type="primary" @click="savePoster">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import EventHead from '@/common/components/eventHead/EventHead';
import FImageUpload from '@/common/components/Upload/f-image-upload.vue';
export default {
    components: { FImageUpload, EventHead },
    data() {
        return {
            matchContent: [],
            form: {},
            sponsorOption: [{
                value: 1,
                label: "主办方"
            },
            {
                value: 2,
                label: "冠名赞助商"
            },
            {
                value: 3,
                label: "赛事赞助商"
            }],
            sponsorData: [],
            title: "",
            sponsorTitle: "",
            posterTitle: "",
            isActive: true,
            posterVisible: false,
            sponsorForm: {},
            posterData: [],
            posterForm: {},
            matchInfo: {}
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getPosterList()
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 获取海报列表
        async getPosterList() {
            const { res } = await this.$http.get(`/Match/MatchPosterList/${this.matchInfo.matchId}`);
            this.posterData = res.data || [];
        },
        // 新增海报
        addPoster() {
            this.posterVisible = true
            this.posterTitle = "新增海报"
        },
        // 保存海报
        savePoster() {
            this.posterForm.matchId = this.matchInfo.matchId,
                this.$confirm('请核实信息，确定要保存该海报吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async () => {
                    const { res } = await this.$http.post('/Match/SaveMatchPoster', this.posterForm);
                    if (res.isSuccess) {
                        this.$showSuccess('发布成功');
                        this.posterVisible = false
                        this.getPosterList();
                    }
                });
        },
        // 关闭弹窗
        closePosterDialog() {
            this.posterVisible = false;
            this.posterTitle = '';
            this.posterForm = {};
        },
        // 删除海报
        deletePoster(row) {
            this.$confirm('请核实信息，确定要删除该海报吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.get(`/Match/DeleteMatchPoster/${row.matchPosterId}`);
                if (res.isSuccess) {
                    this.$showSuccess('删除成功');
                    this.getPosterList();
                }
            });
        },
        changePosterPic() {

        }
    },
};
</script>

<style lang="scss" scoped>
.infoPage {
    width: 100%;
    height: 100%;
    margin-top: 40px;
    background-color: #fff;

    .bread-crumb {
        height: 30px;
    }

    .overviewCommand_detail {
        height: auto;
        width: 100%;

        .list-area {
            margin-top: 10px;
            display: flex;
            width: 100%;
        }

        .top-area {
                    display: flex;
                    align-items: center;
                    color: #fff;
                    width: 100%;
                    height: 40px;
                    font-size: 15px;
                    background-color: #10a2db;
                    border-radius: 10px 10px 0 0;
                }

        .basic-left {
            margin-top: 10px;
            display: flex;
            align-items: center;
            margin-left: 100px;
            width: 50%;
        }

        .basic-right {
            display: flex;
            align-items: center;
            width: 40%;

            .card-item {
                width: 60%;
                margin-left: 100px;
                height: 240px;
                margin-right: 20px;

                .content-area {
                    height: auto;
                    background-color: #fff;
                }
            }
        }
        .view-area{
            width: 60%;
            margin: 0 10px;
        }
    }
}

.info-title {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    background-color: #dbdbdb;

    .markTitle {
        height: 18px;
        width: 5px;
        margin-left: 30px;
        border-radius: 10px;
        background-color: rgb(51, 64, 84);
    }

    .titleImage {
        margin-left: 30px;
        width: 20px;
        height: 20px;
    }

    .title {
        margin-left: 10px;
        color: #409EFF;
        font-size: 15px;
    }
}



.group-name {
    display: flex;
    align-items: center;

    .group {
        width: 5px;
        height: 22px;
        background-color: #2ba245;
        border-radius: 2px;
    }

    .name {
        margin-left: 10px;
        font-weight: 700;
        font-size: 20px;
    }
}

.cardinal {
    margin-top: 30px;
}

.matchDate {
    display: flex;
}

.block {
    margin-right: 60px;
}

.add {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0 10px;
    background-color: #fff;
    border-bottom: 1px solid #a5a1a1;
}

.application-price,
.bond-price {
    display: flex;
    align-items: center;
    width: 300px;
    height: 40px;
    margin: 20px;
    font-size: 18px;
    border: 1px solid #2ba245;
    border-radius: 20px;
}

.cation-title,
.bond-title {
    width: 200px;
    background-color: #2ba245;
    text-align: center;
    line-height: 40px;
    color: #fff;
    border-radius: 18px 0 0 18px;
}

.price,
.bond {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.inputPrice,
.inputBond {
    width: 60%;
    font-size: 14px;
    // background-color: #fff;
}

.matchArea {
    background-color: #fff;
    width: 60%;
    height: 40%;
    border-radius: 10px;
    padding: 20px;
}

.bondTitle {
    display: flex;
    align-items: center;
    font-weight: 400;
    color: #eb7777;
}

.bondIcon {
    width: 30px;
    height: 30px;
    margin-right: 20px;
}

.deduct {
    width: 90%;
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.redCard,
.yellowCard {
    margin: 30px 10px;
    display: flex;
    align-items: center;
}

.inputDeduct {
    width: 30%;
    margin-left: 10px;
    border-bottom: 1px solid #cfcfcf;
}

.inputMax,
.inputMin {
    margin-left: 10px;
    border-bottom: 1px solid #cfcfcf;
}

.promptText {
    width: 90%;
    color: #2ba245;
    opacity: 0.6;
}

.saveButton {
    background-color: #10a2db;
    width: 150px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
}

.statistics {
    background-color: #fff;
    width: 80%;
    height: 40%;
    border-radius: 10px;
    padding: 20px;
}

.enlist,
.cost {
    display: flex;
    justify-content: center;
    font-size: 18px;
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;
}

.feeArea {
    background-color: #fff;
    width: 60%;
    height: 40%;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 30px;
}

.feeSet {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.introduce-area {
    display: flex;
    justify-content: space-around;

    .match-info,
    .match-reward {
        width: 40%;
    }
}

.describe-area {
    margin-top: 60px;
    display: flex;
    justify-content: space-around;

    .match-info,
    .match-reward {
        width: 40%;
    }
}

.group-name {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .group {
        width: 5px;
        height: 20px;
        background-color: #2ba245;
        border-radius: 2px;
    }

    .name {
        margin-left: 10px;
        font-weight: 400;
        font-size: 16px;
    }
}

.operate-btn-com {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 15px;
    border-bottom: 1px solid #333;

    img {
        cursor: pointer;
    }
}

.schedule-table {
    flex: 1;

    /deep/ .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 48px);
    }
}

.sponsor {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .sponsorName,
    .sponsorType {
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
}

.submit-btn {
    width: 200px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #2ba245;
    border: none;
}
</style>